import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "i-assistant-home",
    component: () => import("@/src/views/homepage/IAssistantHome.vue"),
    meta: { public: true },
  },
  {
    path: "/market",
    name: "market",
    component: () => import("@/src/views/homepage/AppStore.vue"),
    meta: { public: true },
  },
  {
    path: "/market/:slug+",
    name: "market-detail",
    component: () => import("@/src/views/homepage/AppDetail.vue"),
    props: (route) => ({
      slug: Array.isArray(route.params.slug)
        ? route.params.slug.join("/")
        : route.params.slug,
    }),
    meta: { public: true },
  },
  {
    path: "/terms",
    name: "terms",
    component: () => import("@/src/views/homepage/Terms.vue"),
    meta: { public: true },
  },
  {
    path: "/privacy-policy",
    name: "privacy-policy",
    component: () => import("@/src/views/homepage/PrivacyPolicy.vue"),
    meta: { public: true },
  },
  {
    path: "/pricing",
    name: "pricing",
    component: () => import("@/src/views/homepage/Pricing.vue"),
    meta: { public: true },
  },
];

export default createRouter({
  history: createWebHistory("/"),
  routes,
});
